<template>
  <div :id="containerId" ref="chartContainer"></div>
</template>

<script>
export default {
  name: 'TradingViewChart',

  props: {
    symbol: {
      type: String,
      required: true
    },
    interval: {
      type: String,
      default: 'D'
    },
    theme: {
      type: String,
      default: 'dark'
    },
    containerId: {
      type: String,
      default: 'tv_chart_container'
    }
  },

  data() {
    return {
      widget: null
    }
  },

  mounted() {
    if (window.TradingView) {
      this.createWidget()
    } else {
      const script = document.createElement('script')
      script.src = 'https://s3.tradingview.com/tv.js'
      script.async = true
      script.onload = () => {
        this.createWidget()
      }
      document.head.appendChild(script)
    }
  },

  methods: {
    createWidget() {
      this.widget = new window.TradingView.widget({
        container_id: this.containerId,
        width: '100%',
        height: '100%',
        symbol: this.symbol,
        interval: this.interval,
        theme: this.systemTheme === 'darkMode' ? 'dark' : 'ligh',
        style: '1',
        locale: 'en',
        toolbar_bg: '#12191e',
        backgroundColor: this.systemTheme === 'darkMode' ? '#12191e' : '#f0f0f1',
        enable_publishing: false,
        allow_symbol_change: false,
        hide_top_toolbar: false,
        hide_side_toolbar: false,
        withdateranges: true,
        details: false,
        studies: [],
      })
    }
  },

  beforeUnmount() {
    // if (this.widget && this.widget.remove) {
    //   this.widget.remove()
    // }
  }
}
</script>
